import { render, staticRenderFns } from "./wuliu_info.vue?vue&type=template&id=1b0ab8af&scoped=true"
import script from "./wuliu_info.vue?vue&type=script&lang=js"
export * from "./wuliu_info.vue?vue&type=script&lang=js"
import style0 from "./wuliu_info.vue?vue&type=style&index=0&id=1b0ab8af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ab8af",
  null
  
)

export default component.exports